import * as React from 'react';
import {Link} from 'react-router-dom';
import {styled} from '../../../utils';
import {getType} from 'mobx-state-tree';
import Ellipsis from '../../../components/Ellipsis';
import Flex from '../../../components/Flex';
import Text from '../../../components/Text';
import {TextFormat, TextFormatType} from '../../../models/chatChannelModel/message/format';
import listingImagePlaceholder from '../../../images/listing-image-placeholder.png';
import ListingPreviewImage from '../../../components/ListingPreviewImage';
import {ChatChannel} from '../../../models/chatChannelModel';
import {padding} from 'polished';

interface ChatItemProps {
  channel: ChatChannel;
  isActive: boolean;
}

const ChatItemRoot = styled('li')<{isActive: boolean}>(
  {
    borderBottom: '1px solid #F1F3F6',
    position: 'relative',
    height: 114,
    borderLeft: '2px solid transparent',
    ':hover': {
      background: '#F5F5F5'
    }
  },
  ({isActive, theme}) => {
    if (isActive) {
      return {
        background: '#F5F5F5',
        borderLeftColor: theme.color.secondary
      };
    }
    return {};
  }
);

const ChatItemLink = styled(Link)({
  color: 'inherit',
  textDecoration: 'inherit',
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  ...padding(0, 16)
});

// FIXME: external channel should have thread
export default class GuestChatItem extends React.Component<ChatItemProps, {}> {
  public render() {
    const {
      channel: {id, name, type, lastMessage, thread},
      isActive
    } = this.props;

    const previewImageUrl = thread && thread!.listing ? thread!.listing!.previewImageUrl : listingImagePlaceholder;

    return (
      <ChatItemRoot isActive={isActive}>
        <ChatItemLink to={`/messages/${type.toLowerCase()}/${id}`}>
          <div style={{width: '100%'}}>
            <Flex style={{width: '100%'}}>
              <ListingPreviewImage
                src={previewImageUrl}
                badge={thread ? thread!.source : undefined}
                style={{marginRight: 8}}
              />
              <Flex direction="column" justify="space-between" wrap="wrap" style={{minWidth: 0}}>
                <Text fontSize={16} lineHeight="24px">
                  {name}
                </Text>
                <div>
                  {lastMessage && getType(lastMessage.format) === TextFormat ? (
                    <Ellipsis>
                      <Text color="#888A90" fontSize={12}>
                        {lastMessage.senderName}: {(lastMessage.format as TextFormatType).text}
                      </Text>
                    </Ellipsis>
                  ) : null}
                  {thread && thread.listing ? (
                    <Ellipsis>
                      <Text fontWeight={700} fontSize={12} withComponent="div">
                        {thread.listing.name}
                      </Text>
                    </Ellipsis>
                  ) : null}
                </div>
              </Flex>
            </Flex>
          </div>
        </ChatItemLink>
      </ChatItemRoot>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/ChatList/private/GuestChatItem.tsx